import React from "react";
import { CheckCircle2, AlertTriangle, XCircle } from "lucide-react";

function relTime(iso) {
  if (!iso) return null;
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return null;
  const secs = Math.max(0, Math.round((Date.now() - then) / 1000));
  if (secs < 45) return "just now";
  const mins = Math.round(secs / 60);
  if (mins < 60) return `${mins} min ago`;
  const hrs = Math.round(mins / 60);
  if (hrs < 24) return `${hrs} hr${hrs === 1 ? "" : "s"} ago`;
  const days = Math.round(hrs / 24);
  return `${days} day${days === 1 ? "" : "s"} ago`;
}

const TONES = {
  emerald: "border-emerald-200 bg-emerald-50 text-emerald-900",
  amber: "border-amber-200 bg-amber-50 text-amber-900",
  rose: "border-rose-200 bg-rose-50 text-rose-900",
};
const ICON_TONES = { emerald: "text-emerald-600", amber: "text-amber-600", rose: "text-rose-600" };

/* At-a-glance Authorize.Net webhook health for the Admin → Billing page. */
export default function WebhookHealthBadge({ settings }) {
  const configured = !!settings?.anet?.configured;
  const env = settings?.anet?.env || "sandbox";
  const lastAt = settings?.webhook_last_event_at;
  const lastType = settings?.webhook_last_event_type || "";
  const rel = relTime(lastAt);

  let tone, Icon, title, sub;
  if (!configured) {
    tone = "rose";
    Icon = XCircle;
    title = "Payments not connected";
    sub = "Add your Authorize.Net keys below to start accepting payments.";
  } else if (!lastAt) {
    tone = "amber";
    Icon = AlertTriangle;
    title = "Connected · awaiting first webhook";
    sub = "Register the webhook URL below in your Authorize.Net dashboard, then run a test payment to confirm it's firing.";
  } else {
    tone = "emerald";
    Icon = CheckCircle2;
    title = "Payments connected \u2713";
    sub = `Last webhook ${rel}${lastType ? ` · ${lastType.replace("net.authorize.", "")}` : ""}.`;
  }

  return (
    <div className={"rounded-md border px-3.5 py-3 flex items-start gap-3 " + TONES[tone]} data-testid="webhook-health-badge">
      <Icon className={"h-5 w-5 shrink-0 mt-0.5 " + ICON_TONES[tone]} data-testid="webhook-health-icon" />
      <div className="min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span className="text-sm font-semibold" data-testid="webhook-health-title">{title}</span>
          {configured ? (
            <span
              className={"inline-flex items-center rounded-full border px-1.5 py-0.5 text-[10px] uppercase tracking-wide font-medium " + (env === "production" ? "border-emerald-300 text-emerald-700" : "border-amber-300 text-amber-700")}
              data-testid="webhook-health-env"
            >
              {env === "production" ? "Live" : "Sandbox"}
            </span>
          ) : null}
        </div>
        <p className="text-xs mt-0.5 opacity-90" data-testid="webhook-health-sub">{sub}</p>
      </div>
    </div>
  );
}
